export default {
  en: {
    name: "Name",
    sla_target: "SLA Target (%)",
    critical_threshold: "Critical Threshold (%)",
    eval_period: "Evaluation Period (Hours)",
    min_calls: "Minimum Calls",
    in_app_notification: "In App Notification",
    sms_notification: "SMS Notification",
    email_notification: "Email Notification",
    short_abandon_timeout: "Short Abandon Timeout (s)",
    target_answer_time: "Target Answer Time (s)",
    enabled: "Enabled",
    abandonment: "Abandonment Rate",
    call_resolution: "First Call Resolution",
    handle_time: "Average Handle Time",
    satisfaction: "Customer Satisfaction Score",
    service_level: "Service Level",
    wait_time: "Average Wait Time",
    update: "Update",
    tab_service_metrics: "Service Metrics",
    tab_time_metrics: "Time Metrics",
    tab_quality_metrics: "Quality Metrics",
    sla_rules: {
      sla_min: "SLA must be greater than 0",
      sla_max: "SLA must be less than 100",
      sla_must_be_number: "SLA must be a number",
    },
    threshold_rules: {
      threshold_min: "Threshold must be greater than 0",
      threshold_max: "Threshold must be less than 100",
      threshold_must_be_number: "Threshold must be a number",
    },
    period_rules: {
      period_min: "Period must be greater than 0",
      period_must_be_number: "Period must be a number",
    },
    minimum_rules: {
      minimum_min: "Minimum must be greater than 0",
      minimum_must_be_number: "Minimum must be a number",
    },
    answer_time_rules: {
      answer_time_min: "Answer time must be greater than 0",
      answer_time_must_be_number: "Answer time must be a number",
    },
    small_abandon_rules: {
      small_abandon_min: "Small abandon must be greater than 0",
      small_abandon_must_be_number: "Small abandon must be a number",
    },
  },
  ar: {
    name: "الاسم",
    sla_target: "الهدف (%)",
    critical_threshold: "الحد الحرج (%)",
    eval_period: "فترة التقييم (ساعات)",
    min_calls: "الحد الأدنى للمكالمات",
    in_app_notification: "الإشعارات الداخلية",
    sms_notification: "الإشعارات النصية",
    email_notification: "الإشعارات البريدية",
    short_abandon_timeout: "الوقت المحدد للإنهاء المبكر (ثوان)",
    target_answer_time: "الوقت المستهدف للرد (ثوان)",
    enabled: "مفعل",
    abandonment: "معدل الإنهاء المبكر",
    call_resolution: "حل المكالمة الأولى",
    handle_time: "متوسط وقت التعامل",
    satisfaction: "درجة الرضا عن العميل",
    service_level: "مستوى الخدمة",
    wait_time: "متوسط وقت الانتظار",
    update: "تحديث",
    tab_service_metrics: "مقاييس الخدمة",
    tab_time_metrics: "مقاييس الوقت",
    tab_quality_metrics: "مقاييس الجودة",
    sla_rules: {
      sla_min: "الهدف يجب أن يكون أكبر من 0",
      sla_max: "الهدف يجب أن يكون أقل من 100",
      sla_must_be_number: "الهدف يجب أن يكون رقم",
    },
    threshold_rules: {
      threshold_min: "الحد الحرج يجب أن يكون أكبر من 0",
      threshold_max: "الحد الحرج يجب أن يكون أقل من 100",
      threshold_must_be_number: "الحد الحرج يجب أن يكون رقم",
    },
    period_rules: {
      period_min: "الفترة يجب أن يكون أكبر من 0",
      period_must_be_number: "الفترة يجب أن يكون رقم",
    },
    minimum_rules: {
      minimum_min: "الحد الأدنى للمكالمات يجب أن يكون أكبر من 0",
      minimum_must_be_number: "الحد الأدنى للمكالمات يجب أن يكون رقم",
    },
    answer_time_rules: {
      answer_time_min: "الوقت المستهدف للرد يجب أن يكون أكبر من 0",
      answer_time_must_be_number: "الوقت المستهدف للرد يجب أن يكون رقم",
    },
    small_abandon_rules: {
      small_abandon_min: "الوقت المحدد للإنهاء المبكر يجب أن يكون أكبر من 0",
      small_abandon_must_be_number:
        "الوقت المحدد للإنهاء المبكر يجب أن يكون رقم",
    },
  },
};
